'use client';

import type { ReactNode } from 'react';

import type { AbstractIntlMessages } from 'next-intl';
import { NextIntlClientProvider } from 'next-intl';

import dynamic from 'next/dynamic';

import { AnalyticsMetrics } from '@/components/analytics';
import { ThemeModeProvider } from '@/context';

const CalendlyPopupSync = dynamic(
  () => import('@/components/book-a-demo-button/calendly/CalendlyPopupSync'),
  {
    ssr: false,
  },
);

const DeferredOverlayRenderer = dynamic(
  () => import('@wci-tech/core-ui').then((mod) => mod.OverlayRenderer),
  {
    ssr: false,
  },
);

interface AppProviderProps {
  children: ReactNode;
  locale: string;
  messages: AbstractIntlMessages;
  initialTheme: 'light' | 'dark';
}

export const AppProvider = ({ children, locale, messages, initialTheme }: AppProviderProps) => {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="Asia/Kolkata">
      <ThemeModeProvider initialTheme={initialTheme}>
        <CalendlyPopupSync />

        <DeferredOverlayRenderer />

        {children}

        <AnalyticsMetrics />
      </ThemeModeProvider>
    </NextIntlClientProvider>
  );
};
